module.exports = __webpack_public_path__ + "static/img/icon-pay-fail.fba34cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jidayi-hospital/icon-pay-fail.png
// module id = POmX
// module chunks = 1